<div [id]="id()" tabindex="-1" class="fixed top-0 left-0 right-0 z-50 hidden w-full p-4 overflow-x-hidden overflow-y-auto md:inset-0 h-[calc(100%-1rem)] max-h-full">
    <div class="relative w-97.75 max-h-full rounded-lg">
        <form #form novalidate (ngSubmit)="onSubmit()">
            <div class="relative primary-purple-light-2-background rounded-lg shadow dark:bg-gray-700 p-6">
                @if (!updating()) {
                    <section class="flex justify-center items-center">
                        <h3 class="w-full text-base font-bold primary-purple-text">{{ literalService.get('setup.modal.confirmUpdate.title', true) }}</h3>
                        <button (click)="close()" type="button" class="absolute right-2 mr-4 text-gray-400 bg-transparent hover:bg-gray-200 hover:text-gray-900 rounded-lg text-sm w-8 h-8 ml-auto inline-flex justify-center items-center dark:hover:bg-gray-600 dark:hover:text-white">
                            <img [src]="images.close" class="h-6 w-6" />
                        </button>
                    </section>

                    <!-- Update Section -->
                    @if (showUpdateSection) {
                        <section class="mt-6">
                            <p class="text-sm">{{ literalService.get('setup.modal.confirmUpdate.description', true) }}</p>
                        </section>
                        <section class="mt-6">
                            <div class="flex items-center justify-between">
                                <div class="flex gap-2 items-center min-w-0 mr-2">
                                    <img [src]="images.availabilities.edit" alt="apply" class="h-6 w-6 shrink-0" />
                                    <label class="font-bold">{{ literalService.get('setup.modal.confirmUpdate.applyToAvailabilities', true) }}</label>
                                </div>
                                <app-toggle [id]="'applyToAvailabilities'" [checked]="applyToAvailabilities" (change)="changeToggleApplyToAvailabilities()" class="shrink-0"></app-toggle>
                            </div>

                            <div class="flex items-center justify-between mt-4">
                                <div class="flex gap-2 items-center min-w-0 mr-2">
                                    <img [src]="images.availabilities.trip" alt="trips" class="h-7 w-7 shrink-0" />
                                    <label class="font-bold">{{ literalService.get('setup.modal.confirmUpdate.updateTrips', true) }}</label>
                                </div>
                                <app-toggle [id]="'updateTrips'" [checked]="updateTrips" (change)="updateTrips = !updateTrips;" class="shrink-0" [disabled]="!applyToAvailabilities"></app-toggle>
                            </div>

                            <div class="flex items-center justify-between mt-4">
                                <div class="flex gap-2 items-center min-w-0 mr-2">
                                    <img [src]="images.booking.notifications" alt="notify" class="h-6 w-6 shrink-0" />
                                    <label class="font-bold">{{ literalService.get('setup.modal.confirmUpdate.sendNotification', true) }}</label>
                                </div>
                                <app-toggle [id]="'sendNotificationUpdate'" [checked]="sendNotificationUpdate" (change)="sendNotificationUpdate = !sendNotificationUpdate;" class="shrink-0" [disabled]="!applyToAvailabilities"></app-toggle>
                            </div>
                        </section>
                    }

                    <!-- Delete Section -->
                    @if (showDeleteSection) {
                        <section class="mt-6" [ngClass]="{'border-t pt-6': showUpdateSection}">
                            <div class="flex items-center justify-between">
                                <div class="flex gap-2 items-center min-w-0 mr-2">
                                    <img [src]="images.availabilities.delete" alt="delete" class="h-6 w-6 shrink-0" />
                                    <label class="font-bold">{{ literalService.get('setup.modal.confirmUpdate.deleteOrphanedAvailabilities', true) }}</label>
                                </div>
                                <app-toggle [id]="'deleteOrphanedAvailabilities'" [checked]="deleteOrphanedAvailabilities" (change)="deleteOrphanedAvailabilities = !deleteOrphanedAvailabilities;" class="flex-shrink-0"></app-toggle>
                            </div>

                            @if (deleteOrphanedAvailabilities) {
                                <div class="mt-4">
                                    <div class="flex gap-2 mb-2 items-center">
                                        <img [src]="images.comment" alt="comment" class="h-6 w-6 shrink-0" />
                                        <label class="font-normal text-base">{{ literalService.get('comment', true) }}</label>
                                    </div>
                                    <textarea [(ngModel)]="deleteComment" [ngModelOptions]="{standalone: true}" [placeholder]="literalService.get('maxChar150Optional', true)" class="block w-full h-20 px-3 py-2 bg-white border rounded-s rounded-e text-base font-normal placeholder-slate-400 focus:outline-none"></textarea>
                                </div>

                                <div class="flex items-center justify-between mt-4">
                                    <div class="flex gap-2 items-center min-w-0 mr-2">
                                        <img [src]="images.booking.notifications" alt="notify" class="h-6 w-6 shrink-0" />
                                        <label class="font-bold">{{ literalService.get('setup.modal.confirmUpdate.sendNotification', true) }}</label>
                                    </div>
                                    <app-toggle [id]="'sendNotificationDelete'" [checked]="sendNotificationDelete" (change)="sendNotificationDelete = !sendNotificationDelete;" class="flex-shrink-0"></app-toggle>
                                </div>

                                @if (showRefundOptions) {
                                    <div class="flex items-center justify-between mt-4">
                                        <div class="flex gap-2 items-center min-w-0 mr-2">
                                            <label class="font-bold">{{ literalService.get('setup.modal.confirmUpdate.refund', true) }}</label>
                                        </div>
                                        <app-toggle [id]="'refund'" [checked]="refund" (change)="refund = !refund; fullRefund = false;" class="shrink-0"></app-toggle>
                                    </div>

                                    <div class="flex items-center justify-between mt-4">
                                        <div class="flex gap-2 items-center min-w-0 mr-2">
                                            <label class="font-bold">{{ literalService.get('setup.modal.confirmUpdate.fullRefund', true) }}</label>
                                        </div>
                                        <app-toggle [id]="'fullRefund'" [checked]="fullRefund" (change)="fullRefund = !fullRefund; refund = false;" class="shrink-0"></app-toggle>
                                    </div>
                                }

                                @if (showCancelRelated) {
                                    <div class="flex items-center justify-between mt-4">
                                        <div class="flex gap-2 items-center min-w-0 mr-2">
                                            <label class="font-bold">{{ literalService.get('setup.modal.confirmUpdate.cancelRelated', true) }}</label>
                                        </div>
                                        <app-toggle [id]="'cancelRelated'" [checked]="cancelRelated" (change)="cancelRelated = !cancelRelated;" class="shrink-0"></app-toggle>
                                    </div>
                                }
                            }
                        </section>
                    }

                    <section class="flex justify-between items-center mt-8">
                        <button type="button" class="secondary gap-4 p-2 border-2 font-semibold h-10 w-full uppercase cursor-pointer mr-1" (click)="close()">{{ literalService.get('cancel', true) }}</button>
                        <button type="submit" class="primary gap-4 p-2 border-2 font-semibold h-10 w-full uppercase cursor-pointer ml-1">{{ literalService.get('confirm', true) }}</button>
                    </section>
                } @else {
                    <div>
                        <article class="flex w-full pb-6 pt-4 ml-10 pl-7 pr-7 justify-center items-center">
                            <ng-lottie width="75%" height="75%" [options]="loadingAnimation" (animationCreated)="utilsService.animationCreated($event, 1.5)" />
                        </article>
                        <div class="flex items-center justify-center">
                            <h3 class="text-xl font-bold mb-4 -mt-4 text-gray-500 dark:text-gray-400 primary-purple-light-text">{{ literalService.get('setup.modal.confirmUpdate.updating', true) }}</h3>
                        </div>
                    </div>
                }
            </div>
        </form>
    </div>
</div>
